export const ERR_MSG = {
    EMPTY: "This is a required field",
    INVALID_NUMBERS: "Please input a valid numbers",
    INVALID_DATE: "Please input a valid date"
}